import { User } from "firebase/auth";

export function buildFeedbackMailTo(user: User) {
  const subject = "Feedback for Pool Tonight";

  // NOTE(gmike): The below is deliberately formatted this way to make it easier to read in the email client.
  const parts = {
    subject,
    body: `
Hi! I have some feedback for you about the app:

<feedback>

Some info about my session:     
- User ID: ${user.uid}
- User Email: ${user.email}
- Current URL: ${window.location.pathname}
- User Agent: ${navigator.userAgent}

Thanks!
`.trim(),
  };

  const params = new URLSearchParams(parts).toString();
  const mailto = `mailto:feedback@pooltonight.com?${params}`;
  return mailto;
}
